import clsx from 'clsx';
import bgImage from '../../assets/bg-raport-head.jpg';
import type { RaportHeroSectionProps } from './RaportHeroSection.types';

export const RaportHeroSection: React.FC<RaportHeroSectionProps> = ({
  title,
  subtitle,
  progressTitle,
  progressLabel = 'W trakcie przygotowania',
  progressPercentage = 38,
  className,
}) => {
  return (
    <section
      className={clsx(
        'relative w-full overflow-hidden bg-cover bg-center bg-no-repeat h-[560px]',
        className,
      )}
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="absolute z-1 bottom-[-40px] left-0 right-0 h-[200px] bg-no-repeat bg-cover lg:bg-center" style={{ backgroundImage: `url("/src/assets/bg-incoming-raport.png")` }} />
      <div className="container flex flex-col items-center px-4 py-12 text-center lg:py-20">
        {/* Ikona */}
        <div className="flex h-[56px] w-[56px] items-center justify-center rounded-xl bg-primary lg:h-[84px] lg:w-[84px] p-2">
          <svg viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M28.9258 2.07617V8.92817" stroke="#B3D1FF" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M28.9277 48.9121V55.7641" stroke="#B3D1FF" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M55.623 28.9199H48.772" stroke="#B3D1FF" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8.78899 28.9219H1.93799" stroke="#B3D1FF" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M56.604 28.921C56.604 44.203 44.215 56.589 28.922 56.589C13.639 56.589 1.25 44.202 1.25 28.921C1.25 13.638 13.639 1.25 28.922 1.25C44.215 1.25 56.604 13.639 56.604 28.921Z" stroke="#B3D1FF" stroke-width="2.5" stroke-miterlimit="10" />
            <path d="M43.266 17.3008L28.993 31.5708L19.687 22.7748" stroke="#B3D1FF" stroke-width="2.5" stroke-miterlimit="10" />
          </svg>

        </div>

        {/* Tytuł */}
        <h2 className="mt-6 max-w-[963px] font-archivo text-2xl font-bold leading-tight text-white lg:text-[32px] lg:leading-[40px]">
          {title}
        </h2>

        {/* Podtytuł */}
        {subtitle && (
          <p className="mt-3 text-base leading-6 text-heroText lg:text-lg">
            {subtitle}
          </p>
        )}

        {/* Sekcja postępu raportu */}
        {progressTitle && (
          <div className="mt-16 flex flex-col items-center lg:mt-24">
            <h3 className="text-xl font-semibold leading-5 text-heroText lg:text-[26px]">
              {progressTitle}
            </h3>

            {/* Pasek postępu */}
            <div className="relative mt-4 h-[33px] w-[280px] rounded-button border border-progressBar-border bg-progressBar-bg lg:w-[324px]">
              <div
                className="absolute left-0 top-0 h-[33px] rounded-l-button bg-progressBar-fill transition-all duration-500"
                style={{ width: `${Math.min(Math.max(progressPercentage, 0), 100)}%` }}
              />
              <span className="absolute inset-0 flex items-center justify-center text-xs font-bold uppercase tracking-wider text-white">
                {progressLabel}
              </span>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
